import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CENShppingAddressTypeState from "@tCentro/Store/Reducer/CENShippingAddressTypeState";
import CenSpcIsShippingFieldCompletedState from "@tCentro/Store/Reducer/CenSpcIsShippingFieldCompletedState";
import { Draft } from "immer";

const initialState: CENShppingAddressTypeState = {
    ResidentialAddressIndicator: false,
};

const reducer = {
    "Pages/OnePageCheckout/CENShppingAddressTypeState": (draft: Draft<CENShppingAddressTypeState>,
        action: {
            ResidentialAddressIndicator: boolean;
        },) => {

        draft.ResidentialAddressIndicator = action.ResidentialAddressIndicator;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);